var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgMediaFile = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8434 1.12356H6.19296C5.79807 1.12356 5.56578 1.01976 5.27542 0.76329L4.92119 0.451868C4.53791 0.11602 4.23594 0 3.66683 0H1.93628C0.920023 0 0.333496 0.610632 0.333496 1.84411V3.4745H13.6668V3.01042C13.6668 1.75251 13.0571 1.12356 11.8434 1.12356ZM2.15696 11.3333H12.0176C13.0629 11.3333 13.6668 10.6983 13.6668 9.44037V4.30496H0.333496V9.44037C0.333496 10.7044 0.943252 11.3333 2.15696 11.3333Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMediaFile);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/media-file.c3b39d93ce2af33fad235aaf96204213.svg";